export default "__VITE_ASSET__CdznzW$d__"